import axios from "axios";
import { API_URL } from "@/helpers";

export const droneService = {
  getDroneOptions,
  getDroneList,
  addDrone,
  updateDrone,
  deleteDrone,
  getAreas,
  createArea,
  updateArea,
  deleteArea
};

export function getDroneOptions() {
  return axios.get(`${API_URL}/1/drones/`);
}

export function getDroneList() {
  return axios.get(`${API_URL}/1/drones/getdronelist/`);
}

export function addDrone(drone) {
  return axios.post(
    `${API_URL}/1/drones/rpas/add/`,
    (({
      Brand,
      BrandShort,
      DroneName,
      TCCredit,
      TakeoffWeight,
      MaxServiceCeilingAboveSeaLevel,
      OperatingTemperatureRangeLow,
      OperatingTemperatureRangeHigh,
      Controlledairspace,
      Nearpeople,
      Overpeople,
      TakeoffWeighting,
      MaxDistance,
      MaxAscentSpeed,
      MaxDescentSpeed,
      MaxSpeed,
      MaxWindResistance,
      Battery,
      MaxFlightTime,
      RemoteBattery,
      MaxTransmissionDistance
    }) => ({
      Brand,
      BrandShort,
      DroneName,
      TCCredit,
      TakeoffWeight,
      MaxServiceCeilingAboveSeaLevel,
      OperatingTemperatureRangeLow,
      OperatingTemperatureRangeHigh,
      Controlledairspace,
      Nearpeople,
      Overpeople,
      TakeoffWeighting,
      MaxDistance,
      MaxAscentSpeed,
      MaxDescentSpeed,
      MaxSpeed,
      MaxWindResistance,
      Battery,
      MaxFlightTime,
      RemoteBattery,
      MaxTransmissionDistance
    }))(drone)
  );
}

export function updateDrone(drone) {
  return axios.post(
    `${API_URL}/1/drones/rpas/update/`,
    (({
      Brand,
      BrandShort,
      DroneName,
      TCCredit,
      TakeoffWeight,
      MaxServiceCeilingAboveSeaLevel,
      OperatingTemperatureRangeLow,
      OperatingTemperatureRangeHigh,
      Controlledairspace,
      Nearpeople,
      Overpeople,
      TakeoffWeighting,
      MaxDistance,
      MaxAscentSpeed,
      MaxDescentSpeed,
      MaxSpeed,
      MaxWindResistance,
      Battery,
      MaxFlightTime,
      RemoteBattery,
      MaxTransmissionDistance
    }) => ({
      Brand,
      BrandShort,
      DroneName,
      TCCredit,
      TakeoffWeight,
      MaxServiceCeilingAboveSeaLevel,
      OperatingTemperatureRangeLow,
      OperatingTemperatureRangeHigh,
      Controlledairspace,
      Nearpeople,
      Overpeople,
      TakeoffWeighting,
      MaxDistance,
      MaxAscentSpeed,
      MaxDescentSpeed,
      MaxSpeed,
      MaxWindResistance,
      Battery,
      MaxFlightTime,
      RemoteBattery,
      MaxTransmissionDistance
    }))(drone)
  );
}

export function deleteDrone(drone) {
  return axios.delete(
    `${API_URL}/1/drones/rpas/update/`,
    (({
      Brand,
      BrandShort,
      DroneName,
      TCCredit,
      TakeoffWeight,
      MaxServiceCeilingAboveSeaLevel,
      OperatingTemperatureRangeLow,
      OperatingTemperatureRangeHigh,
      Controlledairspace,
      Nearpeople,
      Overpeople,
      TakeoffWeighting,
      MaxDistance,
      MaxAscentSpeed,
      MaxDescentSpeed,
      MaxSpeed,
      MaxWindResistance,
      Battery,
      MaxFlightTime,
      RemoteBattery,
      MaxTransmissionDistance
    }) => ({
      Brand,
      BrandShort,
      DroneName,
      TCCredit,
      TakeoffWeight,
      MaxServiceCeilingAboveSeaLevel,
      OperatingTemperatureRangeLow,
      OperatingTemperatureRangeHigh,
      Controlledairspace,
      Nearpeople,
      Overpeople,
      TakeoffWeighting,
      MaxDistance,
      MaxAscentSpeed,
      MaxDescentSpeed,
      MaxSpeed,
      MaxWindResistance,
      Battery,
      MaxFlightTime,
      RemoteBattery,
      MaxTransmissionDistance
    }))(drone)
  );
}

export function getAreas() {
  return axios.get(`${API_URL}/1/drones/areas/`);
}

export function createArea(area) {
  return axios.post(`${API_URL}/1/drones/area/create/`, area);
}

export function updateArea(area) {
  return axios.put(`${API_URL}/1/drones/area/update/`, area);
}

export function deleteArea(id) {
  return axios.post(`${API_URL}/1/drones/area/delete/`, id);
}
